function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangerousAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#022449",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "cloud-alert",
    "data-name": "Flat Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M13.5,19.5A1.5,1.5,0,1,1,12,18,1.5,1.5,0,0,1,13.5,19.5ZM13,15V12a1,1,0,0,0-2,0v3a1,1,0,0,0,2,0Z",
    style: {
      fill: "rgb(44, 169, 188)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M21.76,9.44A5,5,0,0,0,17.32,6a4.56,4.56,0,0,0-.83,0A6,6,0,0,0,13,4.08a5.91,5.91,0,0,0-4.46,1A6,6,0,0,0,6.37,8a4.07,4.07,0,0,0-2,.31A4,4,0,0,0,6,16h4V12a2,2,0,0,1,2-2h0a2,2,0,0,1,2,2v4h2.91a6.15,6.15,0,0,0,2.21-.46A5,5,0,0,0,21.76,9.44Z",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerousAlarm);
export default __webpack_public_path__ + "static/media/dangerous_alarm.663c1613131ac674d7ab2a62d88f7391.svg";
export { ForwardRef as ReactComponent };